import { Spinner as ChakraSpinner } from "@chakra-ui/react";
import styled, { DefaultTheme } from "styled-components";

type Props = {
  color?: string;
  size: number;
  className?: string;
  thickness?: string;
};

export const Spinner = ({ size, color, thickness = "2px", className }: Props) => {
  return (
    <Wrapper className={className}>
      <ChakraSpinnerStyled boxSize={size} thickness={thickness} color={color} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ChakraSpinnerStyled = styled(ChakraSpinner)`
  color: ${(props: { theme: DefaultTheme }) => props.theme.primaryColor};
`;
